//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQToggle from "../../../../../components/Generics/AQToggle/AQToggle.vue";

export default {
    components: {
        AQToggle
    },
    props: {},
    data() {
        return {
            labelText: "Label",
            option: false,
            lista: ["one"],
            clickValue: "one",
            clickValue1: "two",
            clickValue2: "three",
            checkType: false
        };
    },
    computed: {
    },
    methods: {

    }

};
